import { render } from "./CompactSchoolStats.vue?vue&type=template&id=d4b4ac1c&scoped=true"
import script from "./CompactSchoolStats.vue?vue&type=script&lang=js"
export * from "./CompactSchoolStats.vue?vue&type=script&lang=js"

import "./CompactSchoolStats.vue?vue&type=style&index=0&id=d4b4ac1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b4ac1c"]])

export default __exports__